import React from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";

function DialogModal({
  show,
  onClose,
  title,
  children, // Use children prop for flexible content
  footerButtons, // Prop for custom footer buttons
  showCloseButton = true, // Option to hide the close icon
}) {
  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-11/12 max-w-sm p-6 relative flex flex-col">
        {/* Close Button */}
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close modal"
          >
            <IoIosCloseCircleOutline size={25} />
          </button>
        )}

        {/* Header */}
        {title && (
          <h3 className="text-lg text-center font-semibold text-gray-900 mb-4 pr-8">
            {title}
          </h3>
        )}

        {/* Content (children) */}
        <div className="flex-grow text-sm text-gray-600 mb-6 overflow-y-auto">
          {children}
        </div>

        {/* Action Buttons (Footer) */}
        {footerButtons && (
          <div className="flex justify-end gap-3 mt-auto pt-4 border-t border-gray-100">
            {footerButtons}
          </div>
        )}
      </div>
    </div>
  );
}

export default DialogModal;
